import { render, staticRenderFns } from "./SiteIconAdd.vue?vue&type=template&id=af2aade8&scoped=true"
import script from "./SiteIconAdd.vue?vue&type=script&lang=js"
export * from "./SiteIconAdd.vue?vue&type=script&lang=js"
import style0 from "./SiteIconAdd.vue?vue&type=style&index=0&id=af2aade8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2aade8",
  null
  
)

export default component.exports